"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _default = {
  addUser: function addUser(email) {
    var provisioning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var postBody = Object.assign({}, provisioning, {
      email: email
    });
    return _apiClient.default.post('hubsettings/v1/users/add', {
      data: postBody
    });
  }
};
exports.default = _default;
module.exports = exports.default;